import React, { useEffect, useRef } from "react";
import {
  Table,
  Input,
  Button,
  Typography,
  Divider,
  Modal,
  Popconfirm,
} from "antd";
import Highlighter from "react-highlight-words";
import {
  SearchOutlined,
  DeleteOutlined,
  EditOutlined,
  UserAddOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
// import {
//   ChangeTrainerSearchText,
//   ChangeTrainerTableData,
//   ChangeTrainerModalState,
// } from "../../../actions/adminAction";

import { changeTrainerSearchText } from "../../../reducers/admin";
import Alert from "../../../components/common/alert";
import { SecurePost } from "../../../services/axiosCall";
import apis from "../../../services/Apis";
import NewTrainerForm from "../newTrainer/newtrainer";
import "./alltrainer.css";
import {
  fetchTrainerTableData,
  changeTrainerModalState,
} from "../../../features/adminAsync";

const { Title } = Typography;

const AllTrainer = () => {
  const searchInput = useRef(null);
  const dispatch = useDispatch();

  const {
    trainerTableData,
    loading,
    TrainersearchText,
    showModalTrainer,
    trainerId,
    actionType,
    trainerdetails,
  } = useSelector((state) => state.admin);
  // console.log(trainerTableData);

  useEffect(() => {
    dispatch(fetchTrainerTableData());
  }, [dispatch]);

  const openModal = (id, mode) => {
    dispatch(
      changeTrainerModalState({
        showModal: true,
        trainerId: id,
        actionType: mode,
      })
    );
  };

  const closeModal = () => {
    dispatch(
      changeTrainerModalState({
        showModalTrainer: false,
        trainerId: null,
        actionType: "Register", // reset to default
      })
    );
  };

  const deleteTrainer = (id) => {
    SecurePost({
      url: `${apis.DELETE_TRAINER}`,
      data: { _id: id },
    })
      .then((response) => {
        if (response.data.success) {
          Alert("success", "Success", response.data.message);
          dispatch(fetchTrainerTableData(response.data.data));
        } else {
          Alert("warning", "Warning!", response.data.message);
        }
      })
      .catch((error) => {
        const message = error.response?.data?.message || error.message;
        Alert("error", "Error!", message);
      });
  };

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    dispatch(changeTrainerSearchText(selectedKeys[0]));
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters(); // resets AntD filter state
    confirm(); // closes dropdown and resets table data
    dispatch(changeTrainerSearchText("")); // resets Redux
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters, confirm)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
    filterDropdownProps: {
      onOpenChange: (visible) => {
        if (visible) {
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
        searchWords={[TrainersearchText]}
        autoEscape
        textToHighlight={text?.toString() || ""}
      />
    ),
  });

  const nameColumnSearchProps = getColumnSearchProps("name");
  const emailColumnSearchProps = getColumnSearchProps("emailid");
  const contactColumnSearchProps = getColumnSearchProps("contact");
  const subjectColumnSearchProps = getColumnSearchProps("subject");

  const columns = [
    {
      title: <span style={{ color: "black" }}>Name</span>,
      dataIndex: "name",
      key: "name",
      width: "25%",
      ...nameColumnSearchProps,
      render: (text) => {
        const rendered = nameColumnSearchProps.render
          ? nameColumnSearchProps.render(text)
          : text;
        return <span style={{ color: "black" }}>{rendered}</span>;
      },
    },
    {
      title: <span style={{ color: "black" }}>Email Id</span>,
      dataIndex: "emailid",
      key: "emailid",
      width: "25%",
      ...emailColumnSearchProps,
      render: (text) => {
        const rendered = emailColumnSearchProps.render
          ? emailColumnSearchProps.render(text)
          : text;
        return <span style={{ color: "black" }}>{rendered}</span>;
      },
    },
    {
      title: <span style={{ color: "black" }}>Contact Number</span>,
      dataIndex: "contact",
      key: "contact",
      ...contactColumnSearchProps,
      render: (text) => {
        const rendered = contactColumnSearchProps.render
          ? contactColumnSearchProps.render(text)
          : text;
        return <span style={{ color: "black" }}>{rendered}</span>;
      },
    },
    {
      title: <span style={{ color: "black" }}>Subject</span>,
      dataIndex: "subject",
      key: "subject",
      ...subjectColumnSearchProps,
      render: (text) => {
        const rendered = subjectColumnSearchProps.render
          ? subjectColumnSearchProps.render(text)
          : text;
        return <span style={{ color: "black" }}>{rendered}</span>;
      },
    },
    {
      title: <span style={{ color: "black" }}>Action</span>,
      key: "_id",
      dataIndex: "_id",
      render: (id) => (
        <span>
          <Button
            type="primary"
            shape="circle"
            icon={<EditOutlined />}
            onClick={() => openModal(id, "Save Changes")}
          />
          <Divider type="vertical" />
          <Popconfirm
            title="Are you sure?"
            cancelText="No"
            okText="Yes"
            onConfirm={() => deleteTrainer(id)}
            icon={<DeleteOutlined style={{ color: "red" }} />}
          >
            <Button danger shape="circle" icon={<DeleteOutlined />} />
          </Popconfirm>
        </span>
      ),
    },
  ];

  return (
    <div className="admin-table-container">
      <Button
        type="primary"
        icon={<UserAddOutlined />}
        style={{ marginBottom: "10px" }}
        onClick={() => openModal(null, "Register")}
      >
        Add New Teacher
      </Button>
      <div className="register-trainer-form-header">
        <Title level={4} style={{ color: "#fff", textAlign: "center" }}>
          List of Teachers
        </Title>
      </div>
      <Table
        bordered
        columns={columns}
        dataSource={trainerTableData}
        pagination={{ pageSize: 10 }}
        loading={loading}
        rowKey="_id"
        style={{ backgroundColor: "#fff", padding: "10px" }}
      />
      <Modal
        open={showModalTrainer}
        title={false}
        onCancel={closeModal}
        style={{
          top: 20,
          padding: 0,
          backgroundColor: "rgb(155,175,190)",
        }}
        width="40%"
        footer={null}
      >
        <NewTrainerForm trainerId={trainerId} actionType={actionType} />
      </Modal>
    </div>
  );
};

export default AllTrainer;
